export function setLocalStorage(value) {
	return window.localStorage.setItem('token', value);
}

export function getLocalStorage() {
	return window.localStorage.getItem('token');
}

export function removeLocalStorage() {
	return window.localStorage.clear();
}

export function setUserName(value) {
	return window.localStorage.setItem('username', value)
}